import { Icon } from 'components';
import { Roles } from 'configs/roles';
// import { MainLayout } from 'layouts';
import MainLayout from 'layouts/Main';
import React, { lazy } from 'react';

import { MainRouteKeys } from '../enums';
import { MainRouteObject } from '../types';
import AuditLogsAdminPage from 'pages/audit-logs-admin';
import { Actions } from 'configs/actions';
const UsersPage = lazy(() => import('pages/Users'));
// const TransferPage = lazy(() => import('pages/transfers'));
const PersonalPage = lazy(() => import('pages/Personal'));
const PersonalInfoPage = lazy(() => import('pages/Personal/Info'));
const PersonalFinancialLimitsPage = lazy(
  () => import('pages/Personal/FinancialLimits'),
);
const PersonalTwoFaSecurityPage = lazy(
  () => import('pages/Personal/TwoFaSecurity'),
);
const PersonalChangePasswordPage = lazy(
  () => import('pages/Personal/ChangePassword'),
);
const PersonalBalancePage = lazy(() => import('pages/Personal/Balance'));
const BalanceManagementPage = lazy(
  () => import('pages/Personal/Balance/Manage'),
);
const BalanceTransferPage = lazy(
  () => import('pages/Personal/Balance/Transfer'),
);
// import BalanceTransferToBankPage from 'pages/Personal/Balance/TransferToBank';
const BalanceTransferToBankByBIDVPage = lazy(
  () => import('pages/Personal/Balance/TransferToBankByBIDV'),
);
const PersonalLogoutPage = lazy(() => import('pages/Personal/Logout'));
const TopUpPointsPage = lazy(() => import('pages/top-up-points'));
const UpdateUser = lazy(() => import('pages/update-user'));
const PointTransactionsPage = lazy(() => import('pages/point-transactions'));
const PointTransactionDetailsPage = lazy(
  () => import('pages/point-transactions/details'),
);
const TransactionsPage = lazy(() => import('pages/Transactions'));
const BankManagementPage = lazy(
  () => import('pages/request-withdraw/BankManagement'),
);
const RequestWithdrawOwnPage = lazy(
  () => import('pages/request-withdraw/request-withdraw-own'),
);
const RequestWithdrawOwnDetailPage = lazy(
  () => import('pages/request-withdraw/request-withdraw-own-detail'),
);
const CreateRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/create-request-withdraw'),
);
const CheckRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/check-request-withdraw'),
);
const CheckRequestWithdrawDetailPage = lazy(
  () => import('pages/request-withdraw/check-request-withdraw-detail'),
);
const RequestWithdrawPage = lazy(() => import('pages/request-withdraw'));
const CompanyDepartmentPage = lazy(() => import('pages/company-department'));
const CompanyListPage = lazy(() => import('pages/company-department/company'));
const EInvoiceAccountListPage = lazy(
  () => import('pages/company-department/einvoice-account'),
);
const MerchantCredentialPage = lazy(
  () => import('pages/company-department/merchant-credential'),
);
const WithdrawToMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/WithdrawToMoraPay'),
);
const DepositFromMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/DepositFromMoraPay'),
);
const BidvVirtualAccountPage = lazy(() => import('pages/bidv-virtual-account'));
const BidvVirtualAccountInquiryPage = lazy(
  () => import('pages/bidv-virtual-account/inquiry'),
);
const BidvBankTransferPage = lazy(() => import('pages/bidv-bank-transfer'));
const BidvBankTransferReconciliationPage = lazy(
  () => import('pages/bidv-bank-transfer/reconciliation'),
);
const BidvBankTransferWhitelistPage = lazy(
  () => import('pages/bidv-bank-transfer/whitelist'),
);
const BidvTransHistoryPage = lazy(
  () => import('pages/bidv-bank-transfer/trans-history'),
);
const BidvEkycGuidePage = lazy(
  () => import('pages/bidv-bank-transfer/ekyc-guide'),
);
const BidvTransferDestWhitelistPage = lazy(
  () => import('pages/bidv-bank-transfer/dest-whitelist'),
);
const BidvTransferWithEvidencePage = lazy(
  () => import('pages/bidv-transfer-with-evidence'),
);
const BidvTransferWithEvidenceCreatePage = lazy(
  () => import('pages/bidv-transfer-with-evidence/create'),
);
const BidvTransferWithEvidenceOwnPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/own'),
);
const BidvTransferWithEvidenceAllPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/all'),
);
const BidvTransferWithEvidenceDetailsPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/details'),
);
const SettingsPage = lazy(() => import('pages/settings'));
const AppVersionConfigPage = lazy(() => import('pages/settings/app-version'));
const UnlockSmsRateLimitPage = lazy(
  () => import('pages/settings/unlock-sms-rate-limit'),
);
const BalanceOperationControlsPage = lazy(
  () => import('pages/settings/balance-operation-controls'),
);

export const MainRoutesConfig: MainRouteObject = {
  [MainRouteKeys.Root]: {
    path: MainRouteKeys.Root,
    name: 'Trang chủ',
    title: 'Trang chủ',
    element: <MainLayout />,
    redirectUrl: MainRouteKeys.Personal,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Personal]: {
    path: MainRouteKeys.Personal,
    name: 'Tài khoản',
    title: 'Tài khoản',
    element: <PersonalPage />,
    redirectUrl: MainRouteKeys.PersonalInfo,
    icon: <Icon.Profile />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalInfo]: {
    path: MainRouteKeys.PersonalInfo,
    name: 'Xem thông tin',
    title: 'Xem thông tin ',
    element: <PersonalInfoPage />,
    icon: <Icon.Data />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalFinancialLimits]: {
    path: MainRouteKeys.PersonalFinancialLimits,
    name: 'Quản lý hạn mức',
    title: 'Quản lý hạn mức',
    element: <PersonalFinancialLimitsPage />,
    icon: <Icon.CreditCard />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalTwoFaSecurity]: {
    path: MainRouteKeys.PersonalTwoFaSecurity,
    name: 'Bảo mật 2FA',
    title: 'Bảo mật 2FA',
    element: <PersonalTwoFaSecurityPage />,
    icon: <Icon.Lock />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalChangePassword]: {
    path: MainRouteKeys.PersonalChangePassword,
    name: 'Thay đổi mật khẩu',
    title: 'Thay đổi mật khẩu ',
    element: <PersonalChangePasswordPage />,
    icon: <Icon.ChangePasswordIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalBalance]: {
    path: MainRouteKeys.PersonalBalance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư ',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.Balance,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.DepositFromMoraPay]: {
    path: MainRouteKeys.DepositFromMoraPay,
    name: 'Nạp điểm từ OTBiz Pay',
    title: 'Nạp điểm từ OTBiz Pay',
    element: <DepositFromMoraPay />,
    icon: <Icon.Exchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.WithdrawToMoraPay]: {
    path: MainRouteKeys.WithdrawToMoraPay,
    name: 'Rút điểm thưởng ra OTBiz Pay',
    title: 'Rút điểm thưởng ra OTBiz Pay',
    element: <WithdrawToMoraPay />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalLogout]: {
    path: MainRouteKeys.PersonalLogout,
    name: 'Đăng xuất',
    title: 'Đăng xuất ',
    element: <PersonalLogoutPage />,
    icon: <Icon.Logout />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdraw]: {
    path: MainRouteKeys.RequestWithdraw,
    name: 'Rút điểm',
    title: 'Yêu cầu rút điểm',
    element: <RequestWithdrawPage />,
    redirectUrl: MainRouteKeys.CreateRequestWithdraw,
    icon: <Icon.ClaimIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CreateRequestWithdraw]: {
    path: MainRouteKeys.CreateRequestWithdraw,
    name: 'Tạo yêu cầu rút điểm',
    title: 'Tạo yêu cầu rút điểm',
    element: <CreateRequestWithdrawPage />,
    icon: <Icon.ClaimIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdrawOwn]: {
    path: MainRouteKeys.RequestWithdrawOwn,
    name: 'Quản lý Y/C rút điểm',
    title: 'Quản lý Y/C rút điểm',
    element: <RequestWithdrawOwnPage />,
    icon: <Icon.Collection />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BankManagement]: {
    path: MainRouteKeys.BankManagement,
    name: 'Quản lý Ngân hàng',
    title: 'Quản lý Ngân hàng',
    element: <BankManagementPage />,
    icon: <Icon.Collection />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdrawOwnDetail]: {
    path: MainRouteKeys.RequestWithdrawOwnDetail,
    name: 'Chi tiết Y/C rút điểm',
    title: 'Chi tiết Y/C rút điểm',
    element: <RequestWithdrawOwnDetailPage />,
    icon: <Icon.ViewDetailIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CheckRequestWithdrawList]: {
    path: MainRouteKeys.CheckRequestWithdrawList,
    name: 'Duyệt Y/C rút điểm',
    title: 'Duyệt Y/C rút điểm',
    element: <CheckRequestWithdrawPage />,
    icon: <Icon.ConfirmStatus />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.WithdrawPoint_ListRequest,
  },
  [MainRouteKeys.CheckRequestWithdrawDetail]: {
    path: MainRouteKeys.CheckRequestWithdrawDetail,
    name: 'Chi tiết Y/C rút điểm',
    title: 'Chi tiết Y/C rút điểm',
    element: <CheckRequestWithdrawDetailPage />,
    icon: <Icon.ViewDetailIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.WithdrawPoint_ListRequest,
  },
  [MainRouteKeys.CompanyDepartment]: {
    path: MainRouteKeys.CompanyDepartment,
    name: 'Quản lý Doanh nghiệp/HTX',
    title: 'Quản lý Doanh nghiệp/HTX',
    element: <CompanyDepartmentPage />,
    redirectUrl: MainRouteKeys.Company,
    icon: <Icon.Product />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: [
      Actions.ManageCompany_ListCompany,
      Actions.ManageHiloEInvoiceAccount_List,
      Actions.ManageMerchantCredential_List,
    ],
  },
  [MainRouteKeys.Company]: {
    path: MainRouteKeys.Company,
    name: 'Quản lý Doanh nghiệp/HTX',
    title: 'Quản lý Doanh nghiệp/HTX',
    element: <CompanyListPage />,
    icon: <Icon.Product />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageCompany_ListCompany,
  },
  [MainRouteKeys.EInvoiceAccount]: {
    path: MainRouteKeys.EInvoiceAccount,
    name: 'Quản lý Tài khoản HĐĐT HILO',
    title: 'Quản lý Tài khoản HĐĐT HILO',
    element: <EInvoiceAccountListPage />,
    icon: <Icon.Account />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageHiloEInvoiceAccount_List,
  },
  [MainRouteKeys.MerchantCredential]: {
    path: MainRouteKeys.MerchantCredential,
    name: 'Quản lý Dịch vụ SDK/API',
    title: 'Quản lý Dịch vụ SDK/API',
    element: <MerchantCredentialPage />,
    icon: <Icon.Data />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageMerchantCredential_List,
  },
  [MainRouteKeys.Users]: {
    path: MainRouteKeys.Users,
    name: 'Quản lý người dùng',
    title: 'Quản lý người dùng',
    element: <UsersPage />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.ManageUser_ListUser,
  },
  [MainRouteKeys.UpdateUser]: {
    path: MainRouteKeys.UpdateUser,
    name: 'Cập nhật người dùng',
    title: 'Cập nhật người dùng',
    element: <UpdateUser />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: '',
  },
  [MainRouteKeys.Balance]: {
    path: MainRouteKeys.Balance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.BalanceManage,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BalanceManage]: {
    path: MainRouteKeys.BalanceManage,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <BalanceManagementPage />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transfers]: {
    path: MainRouteKeys.Transfers,
    name: 'Chuyển điểm',
    title: 'Chuyển điểm',
    element: <BalanceTransferPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TopUp]: {
    path: MainRouteKeys.TopUp,
    name: 'Nạp điểm',
    title: 'Nạp điểm',
    element: <TopUpPointsPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  // [MainRouteKeys.TransfersToBank]: {
  //   path: MainRouteKeys.TransfersToBank,
  //   name: 'Chuyển điểm ra Ngân hàng',
  //   title: 'Chuyển điểm ra Ngân hàng',
  //   element: <BalanceTransferToBankPage />,
  //   icon: <Icon.CoinExchange />,
  //   roles: '*',
  // },
  [MainRouteKeys.TransfersToBankBIDV]: {
    path: MainRouteKeys.TransfersToBankBIDV,
    name: 'Chuyển điểm ra Ngân hàng BIDV',
    title: 'Chuyển điểm ra Ngân hàng BIDV',
    element: <BalanceTransferToBankByBIDVPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transactions]: {
    path: MainRouteKeys.Transactions,
    name: 'Quản lý giao dịch',
    title: 'Quản lý giao dịch',
    element: <TransactionsPage />,
    redirectUrl: MainRouteKeys.PointTransactions,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PointTransactions]: {
    path: MainRouteKeys.PointTransactions,
    name: 'Cộng/trừ điểm',
    title: 'Cộng/trừ điểm',
    element: <PointTransactionsPage />,
    icon: <Icon.Account />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PointTransactionDetails]: {
    path: MainRouteKeys.PointTransactionDetails,
    name: 'Chi tiết giao dịch',
    title: 'Chi tiết giao dịch',
    element: <PointTransactionDetailsPage />,
    icon: <Icon.Account />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.AuditLogsAdmin]: {
    path: MainRouteKeys.AuditLogsAdmin,
    name: 'Logs Admin',
    title: 'Logs Admin',
    element: <AuditLogsAdminPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN],
    screenAction: '',
  },
  [MainRouteKeys.BidvVirtualAccount]: {
    path: MainRouteKeys.BidvVirtualAccount,
    name: 'Tài khoản ảo BIDV',
    title: 'Quản lý tài khoản ảo BIDV',
    element: <BidvVirtualAccountPage />,
    icon: <Icon.Wallet />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    redirectUrl: MainRouteKeys.BidvVirtualAccountInquiry,
    screenAction: [
      Actions.ManageBIDVTransaction_Inquiry,
      Actions.ManageBIDVTransaction_Sync,
    ],
  },
  [MainRouteKeys.BidvVirtualAccountInquiry]: {
    path: MainRouteKeys.BidvVirtualAccountInquiry,
    name: 'Tra cứu VA - Có ĐK Thu hộ',
    title: 'Tra cứu VA - Có ĐK Thu hộ',
    element: <BidvVirtualAccountInquiryPage />,
    icon: <Icon.Search />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVTransaction_Inquiry,
      Actions.ManageBIDVTransaction_Sync,
    ],
  },
  [MainRouteKeys.BidvTransHistory]: {
    path: MainRouteKeys.BidvTransHistory,
    name: 'Đồng bộ GD - Không ĐK Thu hộ',
    title: 'Đồng bộ GD - Không ĐK Thu hộ',
    element: <BidvTransHistoryPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVTransaction_Inquiry,
      Actions.ManageBIDVTransaction_Sync,
    ],
  },
  [MainRouteKeys.BidvBankTransfer]: {
    path: MainRouteKeys.BidvBankTransfer,
    name: 'Chuyển tiền BIDV',
    title: 'Quản lý Chuyển tiền BIDV',
    element: <BidvBankTransferPage />,
    icon: <Icon.Wallet />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    redirectUrl: MainRouteKeys.BidvBankTransferReconciliation,
    screenAction: [
      Actions.ManageBIDVBankTransfer_ViewWhitelist,
      Actions.ManageBIDVBankTransfer_UpdateWhitelist,
      Actions.ManageBIDVTransaction_Sync,
    ],
  },
  [MainRouteKeys.BidvBankTransferReconciliation]: {
    path: MainRouteKeys.BidvBankTransferReconciliation,
    name: 'Đối soát giao dịch Chuyển tiền',
    title: 'Đối soát giao dịch Chuyển tiền BIDV',
    element: <BidvBankTransferReconciliationPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.ManageBIDVTransaction_Sync,
  },
  [MainRouteKeys.BidvBankTransferWhitelist]: {
    path: MainRouteKeys.BidvBankTransferWhitelist,
    name: 'Whitelist Chuyển tiền',
    title: 'Quản lý Whitelist Chuyển tiền BIDV',
    element: <BidvBankTransferWhitelistPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVBankTransfer_ViewWhitelist,
      Actions.ManageBIDVBankTransfer_UpdateWhitelist,
    ],
  },
  [MainRouteKeys.BidvEkycGuide]: {
    path: MainRouteKeys.BidvEkycGuide,
    name: 'Hướng dẫn đăng ký eKYC',
    title: 'Hướng dẫn đăng ký dịch vụ BIDV (eKYC)',
    element: <BidvEkycGuidePage />,
    icon: <Icon.Data />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferDestWhitelist]: {
    path: MainRouteKeys.BidvTransferDestWhitelist,
    name: 'Whitelist Người nhận',
    title: 'Quản lý Whitelist Người nhận BIDV',
    element: <BidvTransferDestWhitelistPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVTransferDestWhitelist_List,
      Actions.ManageBIDVTransferDestWhitelist_Create,
      Actions.ManageBIDVTransferDestWhitelist_Update,
      Actions.ManageBIDVTransferDestWhitelist_Delete,
    ],
  },
  [MainRouteKeys.BidvTransferWithEvidence]: {
    path: MainRouteKeys.BidvTransferWithEvidence,
    name: 'Chuyển tiền với chứng từ',
    title: 'Chuyển tiền với Chứng từ',
    element: <BidvTransferWithEvidencePage />,
    icon: <Icon.Wallet />,
    roles: '*',
    redirectUrl: MainRouteKeys.BidvTransferWithEvidenceCreate,
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceCreate]: {
    path: MainRouteKeys.BidvTransferWithEvidenceCreate,
    name: 'Tạo yêu cầu chuyển tiền',
    title: 'Tạo yêu cầu Chuyển tiền với Chứng từ',
    element: <BidvTransferWithEvidenceCreatePage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceOwn]: {
    path: MainRouteKeys.BidvTransferWithEvidenceOwn,
    name: 'Quản lý Y/C chuyển tiền',
    title: 'Yêu cầu chuyển tiền của tôi',
    element: <BidvTransferWithEvidenceOwnPage />,
    icon: <Icon.ManageList />,
    roles: '*',
    screenAction: Actions.ManageTransferWithEvidence_List,
  },
  [MainRouteKeys.BidvTransferWithEvidenceAll]: {
    path: MainRouteKeys.BidvTransferWithEvidenceAll,
    name: 'Duyệt Y/C chuyển tiền',
    title: 'Quản lý tất cả Yêu cầu chuyển tiền',
    element: <BidvTransferWithEvidenceAllPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceDetails]: {
    path: MainRouteKeys.BidvTransferWithEvidenceDetails,
    name: 'Chi tiết Y/C chuyển tiền',
    title: 'Chi tiết Yêu cầu chuyển tiền',
    element: <BidvTransferWithEvidenceDetailsPage />,
    icon: <Icon.Data />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Settings]: {
    path: MainRouteKeys.Settings,
    name: 'Setting',
    title: 'Setting',
    element: <SettingsPage />,
    icon: <Icon.Setting />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    redirectUrl: MainRouteKeys.AppVersionConfig,
    screenAction: [
      Actions.ManageAppVersionConfig_Update,
      Actions.ManageSmsRateLimit_Unlock,
      Actions.ManageBalanceOperationControls_View,
      Actions.ManageBalanceOperationControls_Update,
    ],
  },
  [MainRouteKeys.AppVersionConfig]: {
    path: MainRouteKeys.AppVersionConfig,
    name: 'Version Ứng dụng',
    title: 'Version Ứng dụng',
    element: <AppVersionConfigPage />,
    icon: <Icon.Data />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageAppVersionConfig_Update,
  },
  [MainRouteKeys.UnlockSmsRateLimit]: {
    path: MainRouteKeys.UnlockSmsRateLimit,
    name: 'Unblock SMS Limit',
    title: 'Unblock SMS Limit',
    element: <UnlockSmsRateLimitPage />,
    icon: <Icon.UnlockUserIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageSmsRateLimit_Unlock,
  },
  [MainRouteKeys.BalanceOperationControls]: {
    path: MainRouteKeys.BalanceOperationControls,
    name: 'Cấu hình trừ điểm',
    title: 'Cấu hình trừ điểm',
    element: <BalanceOperationControlsPage />,
    icon: <Icon.Setting />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageBalanceOperationControls_View,
  },
};
